import React from "react";
import SeoLandingPage from "./SeoLandingPage";

const page = {
  title: "Cyprus Airport Transfers | Larnaca and Paphos Taxi Service",
  description:
    "Private Cyprus airport transfers to and from Limassol, Larnaca Airport, Paphos Airport, Nicosia, Ayia Napa and Protaras.",
  canonical: "https://limassolairporttaxi.com/cyprus-airport-transfers",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Airport Transfers" },
    { label: "Cyprus Airport Transfers" },
  ],
  h1: "Cyprus Airport Transfers",
  heroText:
    "Book private airport transfers across Cyprus with direct taxi service for Larnaca Airport, Paphos Airport, Limassol, Nicosia, Ayia Napa, Protaras, and nearby resorts.",
  snapshotLabel: "Coverage",
  snapshotValue: "Islandwide",
  snapshotText:
    "Airport transfer service for both major Cyprus airports and popular destinations across the south of the island.",
  overviewTitle: "Private airport transfers across Cyprus",
  overviewText:
    "Whether you land at Larnaca Airport or Paphos Airport, a private taxi transfer gives you a direct route to your hotel, apartment, home, resort, or business meeting.",
  overviewCards: [
    {
      label: "Larnaca",
      title: "Larnaca Airport transfers",
      text: "Book arrivals and departures for Limassol, Nicosia, Ayia Napa, Protaras, and other destinations from Larnaca Airport.",
    },
    {
      label: "Paphos",
      title: "Paphos Airport transfers",
      text: "Arrange private transfers from Paphos Airport to Limassol, coastal hotels, residential areas, and holiday accommodation.",
    },
    {
      label: "Cyprus",
      title: "Long-distance taxi routes",
      text: "Use one taxi service for airport journeys, intercity transfers, resort travel, and planned trips across Cyprus.",
    },
  ],
  whyTitle: "Why choose private Cyprus airport transfers",
  whyText:
    "Airport arrivals are easier when your transfer is planned before you land. Private taxi service reduces waiting, avoids shared shuttle delays, and keeps luggage handling simple.",
  whyItems: [
    "Transfers to and from both Larnaca and Paphos airports",
    "Door-to-door service for hotels, apartments, homes, and offices",
    "Useful for family travel, business trips, holidays, and residents",
    "Fast confirmation by phone or WhatsApp with trip details",
  ],
  routesTitle: "Popular Cyprus airport transfer routes",
  routesText:
    "Choose the page that best matches your airport route or explore Limassol taxi services for local and long-distance travel.",
  popularRoutes: [
    {
      title: "Limassol to Larnaca Airport Taxi",
      to: "/limassol-to-larnaca-airport-taxi",
      text: "Private taxi transfer from Limassol to Larnaca Airport departures.",
    },
    {
      title: "Limassol to Paphos Airport Taxi",
      to: "/limassol-to-paphos-airport-taxi",
      text: "Reliable taxi from Limassol to Paphos Airport for scheduled flights.",
    },
    {
      title: "Larnaca Airport Taxi",
      to: "/larnaca-airport-taxi",
      text: "Book Larnaca Airport taxi service for Limassol and other Cyprus destinations.",
    },
    {
      title: "Paphos Airport Taxi",
      to: "/paphos-airport-taxi",
      text: "Arrange Paphos Airport taxi transfers to Limassol and surrounding areas.",
    },
  ],
  infoTitle: "How Cyprus airport taxi transfers work",
  infoText:
    "Share your route, date, time, flight number, passenger count, luggage, and destination address. Your transfer can then be planned around airport arrival or departure timing.",
  infoDetails: [
    ["Airports", "Larnaca Airport and Paphos Airport"],
    ["Service", "Private taxi transfers"],
    ["Main base", "Limassol"],
    ["Booking", "Phone or WhatsApp"],
    ["Availability", "24/7 by request"],
    ["Destinations", "Limassol, Nicosia, Ayia Napa, Protaras, resorts"],
  ],
  availabilityTitle: "24/7 airport transfers for Cyprus flights",
  availabilityText:
    "Cyprus flights arrive and depart throughout the day and night. Request airport transfer service for early landings, delayed flights, late departures, holiday periods, and weekend travel.",
  faqTitle: "Cyprus airport transfers FAQ",
  faqs: [
    {
      question: "Which airports do you cover in Cyprus?",
      answer:
        "Airport taxi transfers can be arranged for Larnaca Airport and Paphos Airport, including routes to and from Limassol and other popular areas.",
    },
    {
      question: "Can I book an airport transfer before I arrive?",
      answer:
        "Yes. Pre-booking is recommended so pickup time, destination, luggage, passengers, and flight details can be confirmed in advance.",
    },
    {
      question: "Do you provide transfers outside Limassol?",
      answer:
        "Yes. Transfers can be requested for Nicosia, Ayia Napa, Protaras, coastal resorts, villages, and other Cyprus destinations by arrangement.",
    },
    {
      question: "Are Cyprus airport transfers private?",
      answer:
        "The service is private by request, giving you direct travel without shared shuttle stops or waiting for unrelated passengers.",
    },
    {
      question: "What details should I send when booking?",
      answer:
        "Send your airport, flight number, pickup or drop-off address, date, time, passengers, luggage, and any special requests such as child seats.",
    },
  ],
};

export default function CyprusAirportTransfersPage() {
  return <SeoLandingPage page={page} />;
}
